<template>
    <div class="address-validation">
        <div class="modalWrapper" v-if="showConfirmation">
            <div class="confirmationFormWrapper">
                <form class="confirmationForm">
                    <div class="labels">
                        <h1 v-html="'&nbsp;'" style="text-decoration: none;"/>
                        <div v-text="'Address 1'" />
                        <div v-text="'Address 2'" />
                        <div v-text="'City'" />
                        <div v-text="'State'" />
                        <div v-text="'ZIP'" />
                    </div>
                    <div class="original">
                        <h1 v-html="'Original'" />
                        <div v-html="person.address1.$model || '&nbsp;'" />
                        <div v-html="person.address2.$model || '&nbsp;'" />
                        <div v-html="person.city.$model || '&nbsp;'" />
                        <div v-html="person.state.$model || '&nbsp;'" />
                        <div v-html="person.zip.$model || '&nbsp;'" />
                        <button @click.prevent="override" v-html="'Keep original'" />
                    </div>
                    <div class="validated">
                        <h1 v-html="'Standardized'" />
                        <div v-html="validatedAddress.address1 || '&nbsp;'" :class="diffClass('address1')"/>
                        <div v-html="validatedAddress.address2 || '&nbsp;'" :class="diffClass('address2')" />
                        <div v-html="validatedAddress.city || '&nbsp;'" :class="diffClass('city')" />
                        <div v-html="validatedAddress.state || '&nbsp;'" :class="diffClass('state')" />
                        <div v-html="validatedAddress.zip || '&nbsp;'" :class="diffClass('zip')" />
                        <button @click.prevent="accept" v-text="'Accept changes'" />
                    </div>
                </form>
                <div class="goback">
                    <button @click.prevent="cancel" v-text="'Go back and edit address'" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import _pick from 'lodash.pick';

import LabelInput from '../../_components/form/LabelInput';

export default {
    components: {
        LabelInput,
    },

    props: {
        person: {
            type: Object,
        },
    },

    data() {
        return {
            showConfirmation: false,
            validatedAddress: {},
        };
    },

    computed: {
        address() {
            return {
                address1: this.person.address1.$model,
                address2: this.person.address2.$model,
                city: this.person.city.$model,
                state: this.person.state.$model,
                zip: this.person.zip.$model,
            };
        },
    },

    // watch: {
    //     address: {
    //         deep: true,
    //         handler() {
    //             this.$emit('set-address-status', 1);
    //         },
    //     },
    // },

    methods: {
        validate() {
            let vue = this;

            // vue.$emit('set-address-status', 1);

            return axios.post('/api/address-validation', {
                address: this.address,
            })
                .then(response => {
                    // if (response.data.valid) {
                        console.debug(response.data);
                        if (response.data.unconfirmedFields.length > 0 || response.data.missingFields.length > 0) {
                            vue.$emit('review', {
                                missing: response.data.missingFields ?? [],
                                unconfirmed: response.data.unconfirmedFields ?? []
                            });
                            console.debug('review');
                            return false;
                        }
                        // if (response.data.missingFields.length > 0) {
                        //     vue.$emit('review', {
                        //         missing: response.data.missingFields ?? [],
                        //         unconfirmed: []
                        //     });
                        //     return false;
                        // }

                        if (response.data.anyChanges) {
                            vue.validatedAddress = _pick(response.data.validatedAddress,
                                ['address1', 'address2', 'city', 'state', 'zip']
                            );
                            vue.showConfirmation = true;
                            // console.debug('showForm');
                            return false;
                        }

                        vue.$emit('set-address-status', 2);
                        return true;
                    // } else {
                    //     console.debug('cannot validate');
                    //     // vue.$emit('cannot-validate');
                    // //     vue.$emit('set-address-status', 1);
                    // }
                })
                .catch(error => {
                    vue.$emit('review', {
                        missing: [],
                        unconfirmed: ['address1', 'address2', 'city', 'state', 'zip'],
                    });
                    console.debug('review');
                    return false;
                })
            ;
        },

        diffClass(field) {
            return (this.person[field].$model !== this.validatedAddress[field]) ? 'differs' : '';
        },

        accept() {
            this.$emit('accept', this.validatedAddress);
            this.showConfirmation = false;
        },

        override() {
            this.$emit('override');
            this.showConfirmation = false;
        },

        cancel() {
            this.$emit('cancel');
            this.showConfirmation = false;
        },
    },
}
</script>

<style lang="scss">
.address-validation {
    [class^="icon-"] {
        margin-left: 0;
    }

    button {
        margin-left: 2em;
        font-size: 80%;
    }

    .modalWrapper {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.75);
        z-index: 10;
    }

    .confirmationFormWrapper {
        background-color: white;
        padding: 0;
        width: 80%;

        border-radius: 1vw;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        max-height: 80vh;
        box-sizing: border-box;
        max-width: 32em;
    }

    .confirmationForm {
        padding: 20px;
        display: flex;
        justify-content: space-between;

        h1 {
            font-weight: bold;
            text-decoration: underline;
            font-size: 1.1em;
        }

        div div {
            white-space: nowrap;
        }

        button {
            margin: 15px 0 0 0;
        }
    }

    .labels, .original, .validated {
        div {
            padding: 4px;
        }
    }

    .differs {
        background-color: #ffff77;
    }

    .goback {
        margin: 10px 0 0 0;
        text-align: center;
        border-top: 2px solid black;
        padding: 20px;
        background: #be840b;
        border-radius: 0 0 10px 10px;
    }
}
</style>
